import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chatSearch'
})
@Injectable()
export class ChatsearchPipe implements PipeTransform {
  transform(chat: any[], search: string): any {
    if (!chat) {
      return;
    } else if (!search) {
      return chat;
    } else {
      console.log(search);

      console.log(chat);
      let term = search.toLowerCase();
      return chat.filter(chatTmp => (chatTmp.name && chatTmp.name.toLowerCase().indexOf(term) > -1) || (chatTmp.firstname && chatTmp.firstname.toLowerCase().indexOf(term) > -1) || (chatTmp.message.content && chatTmp.message.content.toLowerCase().indexOf(term) > -1));
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/chatsearch/chatsearch.ts